import { trackInteraction } from '../../usage-tracking/actions/trackInteraction';
import { setConsentToProcessStatus } from '../reducers/gdpr';
import { SHOULD_NOT_ASK_FOR_CONSENT } from 'conversations-internal-schema/widget-data/records/GDPRConsentToProcessStatusTypes';
export function closeConsentToProcess() {
  return dispatch => {
    dispatch(trackInteraction('widget-interaction', {
      action: 'close consent to process'
    }));
    dispatch(setConsentToProcessStatus(SHOULD_NOT_ASK_FOR_CONSENT));
  };
}